module.exports = __webpack_public_path__ + "img/alert-circle.0ad9af2c.svg";